import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useMemo } from 'react'; 
import { useLocation, useNavigate } from 'react-router-dom'; 

import { useAuthContext } from '../../../context';
import { SubNivelAcesso } from '../../../services/api/users/UserServices';

interface IVMReviewProps { 
    id: string;
}

export const VMReview: React.FC<IVMReviewProps> = ({ id }) => {
    const navigate = useNavigate();
    const location = useLocation(); 
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const { userData } = useAuthContext();

    const revisaoPermissoes: SubNivelAcesso = useMemo(() => {
        return userData?.nivel_acesso?.revisao || {};
    }, [userData]); 

    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const hasPermission = (permissionValue: string | null | undefined): boolean => {
        return typeof permissionValue === 'string' && permissionValue !== '';
    };

    return (
        <Box
            display={'flex'}
            flexDirection={smDown ? 'column' : 'row'}
            width={'100%'}
        >
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={smDown ? 'center' : 'start'}
                width={smDown ? '100%' : '50%'}
                padding={1}
            >
                <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registros Legais</Typography> 

                {hasPermission(revisaoPermissoes.RPSB) && (
                    <Button variant={isButtonActive(`/information_dam/${id}/rpsb`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/rpsb`)}>
                        <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Revisão Periódica de Segurança de Barragens (RPSB)</Typography>
                    </Button>
                )}

            </Box>
            <Divider orientation={smDown ? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={smDown ? 'center' : 'start'}
                width={smDown ? '100%' : '50%'}
                padding={1}
            >
            </Box>
        </Box>
    );
};